<template>
  <div>
    <div>
      <b-card
          overlay
          img-alt="Card Image"
          text-variant="black"
          style="margin-top: 25px;"
      >
        <b-card-text>
          <nav-slide-view
              :resource="resource"
              :settings="settings"
          />
        </b-card-text>
      </b-card>
    </div>
    <sessions-sidebar
      :sb-id="formSBId"
      :sb-model="formSBModel"
      :resource="resource"
      :settings="settings"
      @close-clicked="handleCloseSolitudeListSideBar"
    />
    <resource-nav-bar
        v-if="resource"
        :resource="resource"
        @open-about="handleAboutClick"
    >
      <template v-slot:buttons-right>
        <b-button
            v-if="false"
            variant="outline-primary"
            size="md"
            class="my-2 my-md-0"
            @click="handleOpenContactsSideBar"
            style="margin-right: 15px"
        >
          <b-icon icon="telephone" aria-hidden="true" />
        </b-button>
        <b-button
            v-if="false"
            variant="outline-primary"
            size="md"
            class="my-2 my-md-0"
            @click="handleOpenAddContactSideBar"
            style="margin-right: 15px"
        >
          <b-icon icon="telephone-plus" aria-hidden="true" />
        </b-button>
        <b-button
            variant="outline-primary"
            size="md"
            class="my-2 my-md-0"
            @click="handleOpenSideBar"
        >
          <b-icon icon="clipboard-plus" aria-hidden="true" />
        </b-button>
      </template>
    </resource-nav-bar>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import ResourceBlockDisplay from "@/mixins/resourceBlocks/Display";
import ResourceNavBar from "@/components/blockResources/_components/resourceNavBar";
import NavSlideView from "./navSlideView";
import SessionsSidebar from "./sessionsSidebar";

export default {
  name: "Display_Sessions",
  mixins: [ResourceBlockDisplay],
  components: {
    ResourceNavBar,
    SessionsSidebar,
    NavSlideView
  },
  props: {},
  created() {
    //if directly linked here
    if (this.isDeepLinkedSession) {
      this.handleOpenSideBar();
    }
  },
  mounted() {},
  computed: {
    ...mapGetters({
      profile: "user/profile",
      userData: "user/appsData"
    }),
    /* SETTINGS */
    /* USER DATA */
    userDataBends() {
      return this.userData &&
      this.userData &&
      this.userData[`app_${this.resource.toolId}`] &&
      this.userData[`app_${this.resource.toolId}`].bends
          ? this.userData[`app_${this.resource.toolId}`].bends
          : [];
    }
  },
  methods: {
    /** SOlITUDE LIST **/
    handleOpenSideBar() {
      this.formSBModel = true;
    },
    handleCloseSolitudeListSideBar() {
      this.formSBModel = false;
    },
  },
  data() {
    return {
      isDeepLinkedSession: true,
      formSBId: "form-sidebar",
      formSBModel: false,
      /* SLIDE INFO*/
      viewHeight: 250,
      slideId: "audioSlides",
      controls: false,
      indicators: false,
      slide: 0,
      sliding: null,
      mainProps: {
        blank: false,
        blankColor: "#777",
        width: 75,
        height: 75,
        class: "m1"
      }
    };
  }
};
</script>

<style lang="scss" scoped></style>
